import {
  Component, ChangeDetectionStrategy, AfterViewInit, Input, OnChanges, ViewChild,
  ElementRef
} from '@angular/core';


@Component({
  selector: 'iframe-dynamic-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  viewProviders: [],
  templateUrl: './iframe-dynamic-content.html'
})
export class IframeDynamicContentComponent implements AfterViewInit, OnChanges {

  @Input() iframeId: string;
  @Input() htmlDocument: any;
  @Input() scrolling: string;
  @Input() style: any;
  @Input() containerClass: string;
  @Input() disableFixedHeight?: boolean = false;
  @Input() containerHeightDelta: number = 0;
  @ViewChild('dynamiciframe', {static: true}) dynamiciframe: ElementRef;

  ngAfterViewInit() {

    this.setIframeContent();
  }

  ngOnChanges(changes: any): void {

    if (changes.htmlDocument && changes.htmlDocument.currentValue !== null) {
      let iframe: any = this.dynamiciframe.nativeElement;
      if(iframe !== null) {
        //clear content from iframe
        let doc: any = iframe.contentWindow.document || iframe.nativeElement.contentDocument || iframe.nativeElement.contentWindow;
        let blankHtml = '';
        doc.open();
        doc.write(blankHtml);
        doc.close();
        //set new content
        this.setIframeContent();
      }
    }
  }

  setIframeContent() {

    let iframe: any = this.dynamiciframe.nativeElement;
    //set content to iframe
    let doc: any = iframe.contentWindow.document || iframe.nativeElement.contentDocument || iframe.nativeElement.contentWindow;
    doc.open();
    doc.write(this.htmlDocument);
    doc.close();
    //set iframe height up to container height
    let contentContainer: any = <HTMLElement>window.document.getElementsByClassName(this.containerClass)[0];
    if(!this.disableFixedHeight) {
      let height = contentContainer.offsetHeight - this.containerHeightDelta;
      iframe.height=height + 'px';
    }
    else {
      iframe.height = '100%';
    }
  }

}

